// extracted by mini-css-extract-plugin
export default {"container":"titleWithIcon_container__uAPl1","iconContainer":"titleWithIcon_iconContainer__ihi9M","icon":"titleWithIcon_icon__9I5G-","text":"titleWithIcon_text__mogoF"};